import React, { FunctionComponent } from 'react'
import { Navigate, Route, Routes, useNavigate } from 'react-router'

import { AppPath } from '../../../AppPath'
import { PolicyAdjustmentResultRouter } from '../adjustments'
import { AddOnPath } from './AddOnPath'

export const AddOnRouter: FunctionComponent = () => {
  const navigate = useNavigate()

  return (
    <Routes>
      <Route
        key='add-ons-review'
        path={AddOnPath.REVIEW + AppPath.WILDCARD}
        element={
          <PolicyAdjustmentResultRouter
            onComplete={() => navigate('..')}
            onRepeat={() => navigate('..')}
          />
        }
      />

      <Route path='*' element={<Navigate to='../..' />} />
    </Routes>
  )
}
